/**
 * @function delay
 * @description A chainable function for delaying execution of a function or group of them.
 * delay(fn1, 400).delay(fn2, 500).delay(fn3, 800);
 *
 * @param {Function} fn Function to execute
 * @param {Number} t Delay
 *
 * @returns {*}
 */

export default function ( fn = () => {}, t = 100 ) {
	let queue = [];
	let self;
	let timer;

	function schedule( fn, t ) {
		timer = window.setTimeout( function () {
			timer = null;
			fn();
			if ( queue.length ) {
				var item = queue.shift();
				schedule( item.fn, item.t );
			}
		}, t );
	}

	self = {
		delay: function ( fn, t ) {
			// if already queuing things or running a timer,
			//   then just add to the queue
			if ( queue.length || timer ) {
				queue.push( { fn: fn, t: t } );
			} else {
				// no queue or timer yet, so schedule the timer
				schedule( fn, t );
			}
			return self;
		},
		cancel: function () {
			window.clearTimeout( timer );
			queue = [];
			return self;
		}
	};
	return self.delay( fn, t );
}
